
<template>
  <!--文档管理-->
  <div>
    <x-tabula
      :dataSource="dataSource"
      rowKey="article_id"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
      :rowSelection="false"
    >
    </x-tabula>

    <!--推广的弹窗-->
    <a-modal
      title="链接"
      :visible="visible"
      @cancel="closeModal"
      @ok="visible=false"
      v-bind="$store.state.modalConfig"
    >
      <template slot="footer">
        <a-button type="primary" @click="closeModal">确定</a-button>
      </template>

      <a-form-item v-bind="$store.state.modal_ItemLayout">
        <a-row type="flex" :gutter="10">
          <a-col span="18">
            <a-input id="link" v-model="link" placeholder=""></a-input>
          </a-col>
          <a-col>
            <a-button class="link" data-clipboard-target="#link" type="primary">复制</a-button>
          </a-col>
        </a-row>
      </a-form-item>
    </a-modal>
  </div>
</template>

<script>
import mixin from '../../../js/mixins';
import ClipboardJS from 'clipboard';
export default {
  mixins: [mixin.fetchSelect],
  name: 'document',
  data () {
    return {
      link: '',
      visible: false,
      searchList: [
        { props: ['title'], placeholder: '输入标题', inputType: 'input' },
        // eslint-disable-next-line
        { props: ['category_id'], placeholder: '选择分类', options: [], inputType: 'cascader', changeOnSelect: true,
          fieldNames: {label: 'title', value: 'category_id', children: 'children'} }
      ],
      tableOptList: [
        { text: '新增', icon: 'plus', key: 'addbtn' }
      ],
      rowOptList: [
        { text: '修改', handle: (record) => this.$children[0].toEdit(record), key: 'edit' },
        { text: '删除', handle: (record) => this.$children[0].showDeleteConfirm(record), key: 'delete' }
      ],
      columns: [
        { title: 'ID', dataIndex: 'article_id', align: 'left', width: '' },
        { title: '标题', dataIndex: 'title', align: 'left', width: '' },
        { title: '应用位置', dataIndex: 'application_location', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      searchParams: {
        title: '',
        category_id: ''
      },
      listApi: {
        url: '/article',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: 'addDocument',
        title: '修改文档'
      },
      deleteParam: {
        url: '/article',
        param: {pk_key: 'article_id', pk_val: ''},
        title: '文档',
        key: 'title'
      }
    };
  },
  mounted () {
    let paramArr = [{ index: 1, key: 'document_type' }];
    this.marketingManageSelect(paramArr);
  },
  methods: {
    closeModal () {
      this.visible = false;
      this.instance.destroy();
    },
    /** 查看链接 */
    showLink (record) {
      this.link = 'http://www.baidu.com';
      this.visible = true;

      this.$nextTick(() => {
        this.instance = new ClipboardJS('.link');
        this.instance.on('success', (e) => {
          this.$message.success('已复制');
          e.clearSelection();
        });

        this.instance.on('error', (e) => {
          this.$message.error('复制失败');
        });
      });
    },
    resHandle (res) {
      console.log('处理list返回数据: ');
      return res;
    },
    searchHandle (selectData) {
      console.log('处理搜索数据: ', selectData);
      // return selectData;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/marketing/document/document.vue